import * as React from 'react';

export const useCallbackMemoize = <T extends (...args: any[]) => any>(callback: T, deps: React.DependencyList): T => {
    const ref = React.useRef(callback);

    React.useEffect(() => {
        ref.current = callback;
    }, [deps]);

    return React.useMemo(() => {
        return ((...args: any[]) => ref.current(...args)) as T;
    }, [ref]);
}
